import React from "react";
import ContentLoader from "react-content-loader";

function SideMenuLoading() {
  return (
    <ContentLoader
      speed={2} // 속도
      // width={530}
      // height={180}
      viewBox="0 0 500 490"
      backgroundColor="#27292d" // 배경색
      foregroundColor="#4b4b4b" // 요소 색
    >
      <circle cx="50" cy="38" r="30" />
      <rect x="100" y="10" rx="10" ry="10" width="370" height="55" />

      <circle cx="50" cy="108" r="30" />
      <rect x="100" y="80" rx="10" ry="10" width="370" height="55" />

      <circle cx="50" cy="178" r="30" />
      <rect x="100" y="150" rx="10" ry="10" width="370" height="55" />

      <circle cx="50" cy="248" r="30" />
      <rect x="100" y="220" rx="10" ry="10" width="370" height="55" />

      <circle cx="50" cy="318" r="30" />
      <rect x="100" y="290" rx="10" ry="10" width="370" height="55" />

      <circle cx="50" cy="388" r="30" />
      <rect x="100" y="360" rx="10" ry="10" width="370" height="55" />

      <circle cx="50" cy="458" r="30" />
      <rect x="100" y="430" rx="10" ry="10" width="370" height="55" />
    </ContentLoader>
  );
}

export default SideMenuLoading;
